var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['c-onboarding2-showcase', _vm.size]},[(_vm.img)?_c('img',{attrs:{"src":_vm.img}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }